import { render, staticRenderFns } from "./CellRendererTypeServiceText.vue?vue&type=template&id=0ecd4558"
import script from "./CellRendererTypeServiceText.vue?vue&type=script&lang=js"
export * from "./CellRendererTypeServiceText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports